<template>
  <div>
    <vx-breadcrumb
      :list="breadcrumbList"
      class="custom-bread-crumb"
    />
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <div @click="cancelEdit" class="vx-row cursor-pointer">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("Create Ticket Task") }}</h4>
          </div>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <vx-card>
        <form>
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.category')"
                  :key="resetKey"
                >
                  <v-select
                    label="mCodeValue"
                    :options="ticketTemplates.problemsDatas"
                    :placeholder="$t('customers.label.SelectCategory')"
                    :reduce="(mCodeValue) => mCodeValue.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.problemCode"
                    @input="getSubCategory"
                    class="min-w-200 w-full mb-2"
                  >
                    <template v-slot:option="option">{{
                      option.mCodeValue
                    }}</template>
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.sub_category")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.sub_category')"
                  :key="resetKey"
                >
                  <v-select
                    label="subCategory"
                    :options="subCategoryItem"
                    :placeholder="$t('customers.label.SelectSubCategory')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.subCategory"
                    :reduce="(subCategory) => subCategory.id"
                    @input="setTimeAndPriority"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full pb-5">
              <vs-input
                :label="$t('customers.label.ticket_date')"
                class="w-full font-semibold starlabel"
                readonly
                v-model="ticket.ticketDate"
              />
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="pb-5">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.priority')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.priority')"
                    v-model="ticket.priority"
                    class="w-full font-semibold mb-2 starlabel"
                    icon-no-border
                    :danger="false"
                    danger-text="wrong input"
                    disabled="true"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("Reference")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="reference"
                  :key="resetKey"
                >
                  <v-select
                    label="teamDescription"
                    :options="ticketTemplates.TicketTeamMappingData"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.reference"
                    @input="onChangeReference"
                    :reduce="(userName) => userName.id"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("Reference Id")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="reference id"
                  :key="resetKey"
                >
                  <v-select
                    label="username"
                    :options="teamUsers"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.referenceId"
                    :reduce="(userName) => userName.userId"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div> -->
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.team")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="team"
                  :key="resetKey"
                >
                  <v-select
                    label="teamDescription"
                    :options="ticketTemplates.TicketTeamMappingData"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.teamCode"
                    @input="getUserByTeam"
                    :reduce="(userName) => userName.id"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.team_user")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="team user"
                  :key="resetKey"
                >
                  <v-select
                    label="username"
                    :options="teamUsers"
                    placeholder="--Select One--"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="ticket.assignedTo"
                    :reduce="(userName) => userName.userId"
                    class="min-w-200 w-full mb-2"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.source")
                }}</small>
                <v-select
                  label="mCodeValue"
                  :options="ticketTemplates.sourceData"
                  :placeholder="$t('customers.label.SelectSource')"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  class="min-w-200 w-full mb-2"
                  :reduce="(obj) => obj.name"
                  v-model="ticket.sourceOfTicket"
                />
              </div>
            </div>
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label">{{
                  $t("customers.label.due_time")
                }}</small>
                <flat-pickr
                  :config="configdateTimePicker"
                  class="w-full"
                  disabled
                  v-model="ticket.dueTime"
                />
              </div>
            </div>
            <!-- <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team"
                    >
                      <v-select
                        label="teamDescription"
                        :options="ticketTemplates.TicketTeamMappingData"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.teamCode"
                        @input="getUserByTeam"
                        :reduce="(userName) => userName.id"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="vx-col md:w-1/2 w-full">
                  <div class="dropdown-with-label">
                    <small class="date-label"
                      >{{ $t("customers.label.team_user")
                      }}<span class="required"> *</span></small
                    >
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Team user"
                    >
                      <v-select
                        label="username"
                        :options="teamUsers"
                        placeholder="--Select One--"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        v-model="ticket.assignedTo"
                        :reduce="(userName) => userName.userId"
                        class="min-w-200 w-full mb-2"
                      />
                      <span class="validate-error" style="color: red">{{
                        errors[0]
                      }}</span>
                    </ValidationProvider>
                  </div>
                </div> -->
            <div class="vx-col sm:w-full lg:w-1/2 md:w-1/2">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("customers.label.description")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.description')"
                  :key="resetKey"
                >
                  <vs-textarea
                    class="w-full"
                    v-model="ticket.description"
                    rows="5"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <div style="height: 30px"></div>
          <div class="center">
            <span class="ml-1 mr-1">
              <vs-button
                type="border"
                class="footerButton-next"
                style="top: 0px"
                @click="cancelEdit"
                >{{ $t("Cancel") }}</vs-button
              >
            </span>
            <span class="ml-1 mr-1">
              <vs-button
                @click="addTicket"
                class="footerButton-next"
                style="top: 0px"
                >{{ $t("customers.label.submit") }}</vs-button
              >
            </span>
          </div>
          <div style="height: 20px"></div>
        </form>
      </vx-card>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ValidationPopup from "@/components/ValidationPopup.vue";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { setHeader, removeHeader } from "@/http";

const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: "CRM System",
  problemCode: null,
  subCategory: null,
  description: null,
  teamCode: "",
  status: "OPEN",
  title: "",
  // reference: "",
  // referenceId: "",
  type: "Customer",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MM YYYY HH:mm:ss"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: moment().format("HH:mm:ss A"),
};

export default {
  data() {
    return {
      breadcrumbList: [
        { name: "Customers", path: "/customers" },
        {
          name: "View Customer",
          path: `/customers/view_customer/${this.$route.params.id}`,
        },
        {
          name: "Ticket Task",
          path: `/customers/view_customer/${this.$route.params.id}/addticket/${this.$route.params.ticketId}`,
        },
        {
          name: "Create Ticket Task",
        },
      ],
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      resetKey: 0,
      ticket: { ...ticketObj },
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d m Y H:i:s",
      },
      bulkUploads: {
        files: null,
      },
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
  },
  computed: {
    ...mapState({
      ticketTemplates: (state) => state.entity.ticketTemplate,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
      teamUsers: (state) => state.customer.teamUsers,
    }),
  },
  methods: {
    async getUserByTeam() {
      this.ticket.assignedTo = null;
      try {
        this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async onChangeReference() {
      this.ticket.referenceId = null;
      try {
        // this.$store.dispatch("customer/getUserByTeam", this.ticket.teamCode);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getTicketTemplate() {
      try {
        await this.$store.dispatch("entity/setTicketTemplate");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getSubCategory(categoryId) {
      this.ticket.subCategory = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.ticket.subCategory = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    setTimeAndPriority(selectedSubCategory) {
      const subCategoryObj = this.subCategoryItem.find(
        (item) => item.id === selectedSubCategory
      );
      this.ticket.priority = subCategoryObj.priority;
      if (subCategoryObj.timetaken > 0) {
        this.ticket.dueTime =
          subCategoryObj.timetaken * 60 * 60 * 1000 + new Date().getTime();
      } else {
        this.ticket.dueTime = "";
      }
    },
    cancelEdit() {
      this.$router.push({
        path: `/customers/view_customer/${this.$route.params.id}/addticket/${this.$route.params.ticketId}`,
        params: { id: this.$route.params.id },
      });
    },
    async addTicket() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      try {
        const payload = {
          // type: "Customer",
          // problemCode: this.ticket.problemCode,
          // category: this.ticket.problemCode,
          // subCategory: this.ticket.subCategory,
          // ticketDate: this.ticket.ticketDate,
          // priority: this.ticket.priority,
          // teamCode: this.ticket.teamCode,
          // assignedTo: this.ticket.assignedTo,
          // sourceOfTicket: this.ticket.sourceOfTicket,
          // dueTime: this.ticket.dueTime,
          // description: this.ticket.description,
          // locale: "en",
          // dateFormat: "dd MMMM yyyy HH:mm:ss",
          comment: this.ticket.description,
          assignedTo: this.ticket.assignedTo,
        teamCode:  this.ticket.teamCode,
        teamUserId: this.ticket.assignedTo,
        };

        // let formData = new FormData();
        
        // setHeader("Content-Type", "multipart/form-data");
        // if (this.bulkUploads.files && this.bulkUploads.files.length > 0) {
        //   formData.append("name", "attachment");
        //   this.bulkUploads.files.forEach((file) => {
        //     formData.append("file", file);
        //   });
        // }
        // formData.append("ticketData", JSON.stringify(payload));
        // removeHeader("Content-Type");


        await this.$store.dispatch("customer/addCustomerTicketTask", {
          clientId: this.$route.params.ticketId,
          data: payload,
        });
        await this.$swal({
          title: "Success",
          icon: "success",
          text: "Ticket Task Created Successfully!",
          type: "success",
        });
        this.cancelEdit();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
  },
  watch: {},
  async mounted() {
    await this.getTicketTemplate();
  },
};
</script>

<style scoped>
.flatpickr-calendar.open {
  z-index: 999999999999;
}
</style>
